<script lang="ts" setup>
import { useSwiper } from '~/composables/common/use-swiper'
import { useDevice } from '#imports'
import { useInstruction } from '~composables/promotion/use-promotion-static'
import { AccountTabs } from '~/constants/account'
import { eventHalloweenRanking, eventPremierLeagueRanking } from '~/resources/promotion'

const { EVENT_PREMIER_LEAGUE_RANKING_ENABLED, EVENT_HALLOWEEN_ENABLE } = useRuntimeConfig().public
const { modules } = useSwiper()
const { isMobile } = useDevice()
const { promotionBanners } = useInstruction()

const promotionBannerHome = computed(() => {
  const result = [...promotionBanners.value]

  if (EVENT_PREMIER_LEAGUE_RANKING_ENABLED) {
    result.unshift(eventPremierLeagueRanking)
  }

  if (EVENT_HALLOWEEN_ENABLE) {
    result.unshift(eventHalloweenRanking)
  }

  return result
})

defineProps({
  slidesPerView: {
    type: Number,
    default: 3
  },
  spaceBetween: {
    type: Number,
    default: 24
  }
})
</script>
<template>
  <div :class="['promotion', { 'promotion-mobile': isMobile }, { 'promotion-desktop': !isMobile }]">
    <div class="d-flex align-items-center justify-content-between wrapper-title">
      <div :class="['base-title', { mobile: isMobile }]">
        <h2 class="base-title__text">
          <span>Khuyến Mãi</span>
        </h2>
      </div>
      <div class="main-slider-header d-flex align-items-center justify-content-between">
        <NuxtLink :class="['button-link main-slider-header__link', { mobile: isMobile }]" to="/khuyen-mai">
          <span>{{ isMobile ? 'Xem thêm' : 'Xem tất cả' }}</span>
        </NuxtLink>
      </div>
    </div>

    <Swiper
      :modules="modules"
      :slidesPerView="slidesPerView"
      :spaceBetween="spaceBetween"
      :slidesOffsetBefore="isMobile ? 16 : 0"
      :slidesOffsetAfter="isMobile ? 16 : 0"
    >
      <SwiperSlide v-for="(item, index) in promotionBannerHome" :key="index">
        <NuxtLink
          :to="item.isNavigateEventPage ? item.slug : `${AccountTabs.PROMOTION}?tab=${item.slug}`"
          class="promotion__item hover-shine"
        >
          <img :src="item?.imgSrc" :alt="item.title" :height="isMobile ? 105 : 150" />
          <div class="promotion__content">
            <div class="promotion__name">{{ item.title }}</div>
            <div class="promotion__sub">{{ item.subTitle }}</div>
          </div>
        </NuxtLink>
      </SwiperSlide>
    </Swiper>
  </div>
</template>

<style lang="scss" scoped>
@import '~scssAsset/desktop/pages/home/promotion.scss';
</style>
